import React from 'react';
import Logo from './Logo';

const navStyles = {
  wrap: {
    position: 'sticky', top: 0, zIndex: 50,
    background: 'rgba(255,255,255,0.78)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    borderBottom: '1px solid var(--border)',
  },
  inner: {
    maxWidth: 1280, margin: '0 auto',
    padding: '14px 32px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24,
  },
  links: { display: 'flex', gap: 32, fontSize: 14, color: 'var(--fg)', fontWeight: 500 },
  link: { cursor: 'pointer', position: 'relative', padding: '4px 0', transition: 'color 140ms var(--ease-out)' },
  linkActive: { color: 'var(--accent)' },
  cta: {
    fontFamily: 'var(--font-sans)', fontSize: 13, fontWeight: 500,
    padding: '10px 16px', borderRadius: 10,
    background: '#0A0A0A', color: '#fff', border: 'none', cursor: 'pointer',
    transition: 'background 140ms var(--ease-out)',
  },
};

export default function Nav({ active, onNavigate }) {
  const links = [
    { id: 'home', label: 'Portfolio' },
    { id: 'studio', label: 'Studio' },
    { id: 'journal', label: 'Journal' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <nav style={navStyles.wrap}>
      <div style={navStyles.inner}>
        <span onClick={() => onNavigate('home')} style={{ cursor: 'pointer' }}>
          <Logo height={32} />
        </span>
        <div style={navStyles.links}>
          {links.map((l) => (
            <span
              key={l.id}
              onClick={() => onNavigate(l.id)}
              style={{ ...navStyles.link, ...(active === l.id ? navStyles.linkActive : {}) }}
            >
              {l.label}
            </span>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <button style={navStyles.cta} onClick={() => onNavigate('contact')}>
            Say hello <span style={{ marginLeft: 6 }}>→</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
